"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.broadcastTransaction = exports.getOperations = exports.getAccountParams = exports.getAccount = exports.getCroAmount = exports.getClient = void 0;
var chain_jslib_1 = require("@crypto-com/chain-jslib");
var sdk_types_1 = require("./sdk.types");
var bignumber_js_1 = require("bignumber.js");
var network_1 = __importDefault(require("../../../network"));
var logic_1 = require("../logic");
var env_1 = require("../../../env");
var operation_1 = require("../../../operation");
var PAGINATION_LIMIT = 200;
var instances = {};
/**
 * Get CroClient
 */
function getClient(currencyId) {
    return __awaiter(this, void 0, void 0, function () {
        var crypto_org_rpc_url, _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    if (instances[currencyId]) {
                        return [2 /*return*/, instances[currencyId]];
                    }
                    crypto_org_rpc_url = (0, logic_1.isTestNet)(currencyId)
                        ? (0, env_1.getEnv)("CRYPTO_ORG_TESTNET_RPC_URL")
                        : (0, env_1.getEnv)("CRYPTO_ORG_RPC_URL");
                    _a = instances;
                    _b = currencyId;
                    return [4 /*yield*/, (0, logic_1.getCroSdk)(currencyId).CroClient.connect(crypto_org_rpc_url)];
                case 1:
                    _a[_b] = _c.sent();
                    return [2 /*return*/, instances[currencyId]];
            }
        });
    });
}
exports.getClient = getClient;
/**
 * Extract only the cro amount from list of currencies
 */
var getCroAmount = function (amounts, currencyId) {
    var cryptoOrgCurrency = (0, logic_1.isTestNet)(currencyId)
        ? sdk_types_1.CryptoOrgTestnetCurrency
        : sdk_types_1.CryptoOrgCurrency;
    return amounts.reduce(function (result, current) {
        return current.denom === cryptoOrgCurrency
            ? result.plus(new bignumber_js_1.BigNumber(current.amount))
            : result;
    }, new bignumber_js_1.BigNumber(0));
};
exports.getCroAmount = getCroAmount;
/**
 * Get account balances
 */
var getAccount = function (addr, currencyId) { return __awaiter(void 0, void 0, void 0, function () {
    var client, header, crypto_org_indexer, balance, bondedBalance, redelegatingBalance, unbondingBalance, commissions, data, response, error_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, getClient(currencyId)];
            case 1:
                client = _a.sent();
                return [4 /*yield*/, client.getBlock()];
            case 2:
                header = (_a.sent()).header;
                crypto_org_indexer = (0, logic_1.isTestNet)(currencyId)
                    ? (0, env_1.getEnv)("CRYPTO_ORG_TESTNET_INDEXER")
                    : (0, env_1.getEnv)("CRYPTO_ORG_INDEXER");
                balance = new bignumber_js_1.BigNumber(0);
                bondedBalance = new bignumber_js_1.BigNumber(0);
                redelegatingBalance = new bignumber_js_1.BigNumber(0);
                unbondingBalance = new bignumber_js_1.BigNumber(0);
                commissions = new bignumber_js_1.BigNumber(0);
                _a.label = 3;
            case 3:
                _a.trys.push([3, 5, , 6]);
                return [4 /*yield*/, (0, network_1["default"])({
                        method: "GET",
                        url: "".concat(crypto_org_indexer, "/api/v1/accounts/").concat(addr)
                    })];
            case 4:
                response = _a.sent();
                data = response.data;
                return [3 /*break*/, 6];
            case 5:
                error_1 = _a.sent();
                if ((error_1 === null || error_1 === void 0 ? void 0 : error_1.status) !== 404) {
                    throw error_1;
                }
                return [3 /*break*/, 6];
            case 6:
                if (data) {
                    balance = (0, exports.getCroAmount)(data.result.balance, currencyId);
                    bondedBalance = (0, exports.getCroAmount)(data.result.bondedBalance, currencyId);
                    redelegatingBalance = (0, exports.getCroAmount)(data.result.redelegatingBalance, currencyId);
                    unbondingBalance = (0, exports.getCroAmount)(data.result.unbondingBalance, currencyId);
                    commissions = (0, exports.getCroAmount)(data.result.commissions, currencyId);
                }
                return [2 /*return*/, {
                        blockHeight: header.height,
                        balance: new bignumber_js_1.BigNumber(balance),
                        bondedBalance: new bignumber_js_1.BigNumber(bondedBalance),
                        redelegatingBalance: new bignumber_js_1.BigNumber(redelegatingBalance),
                        unbondingBalance: new bignumber_js_1.BigNumber(unbondingBalance),
                        commissions: new bignumber_js_1.BigNumber(commissions)
                    }];
        }
    });
}); };
exports.getAccount = getAccount;
/**
 * Get account information for sending transactions
 */
var getAccountParams = function (addr, currencyId) { return __awaiter(void 0, void 0, void 0, function () {
    var client, _a, accountNumber, sequence;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0: return [4 /*yield*/, getClient(currencyId)];
            case 1:
                client = _b.sent();
                return [4 /*yield*/, client.getAccount(addr)];
            case 2:
                _a = _b.sent(), accountNumber = _a.accountNumber, sequence = _a.sequence;
                return [2 /*return*/, {
                        accountNumber: accountNumber !== null && accountNumber !== void 0 ? accountNumber : 0,
                        sequence: sequence !== null && sequence !== void 0 ? sequence : 0
                    }];
        }
    });
}); };
exports.getAccountParams = getAccountParams;
/**
 * Returns true if account is the signer
 */
function isSender(transaction, addr) {
    return transaction.fromAddress === addr;
}
/**
 * Map transaction to an Operation Type
 */
function getOperationType(messageSendContent, addr) {
    return isSender(messageSendContent, addr) ? "OUT" : "IN";
}
/**
 * Map transaction to a correct Operation Value (affecting account balance)
 */
function getOperationValue(messageSendContent, currencyId) {
    return (0, exports.getCroAmount)(messageSendContent.amount, currencyId);
}
/**
 * Map the send history transaction to a Ledger Live Operation
 */
function convertSendTransactionToOperation(accountId, addr, messageSendContent, transaction, currencyId, memo) {
    var type = getOperationType(messageSendContent, addr);
    return {
        id: (0, operation_1.encodeOperationId)(accountId, messageSendContent.txHash, type),
        accountId: accountId,
        fee: new bignumber_js_1.BigNumber((0, exports.getCroAmount)(transaction.fee, currencyId)),
        value: getOperationValue(messageSendContent, currencyId),
        type: type,
        hash: messageSendContent.txHash,
        blockHash: transaction.blockHash,
        blockHeight: transaction.blockHeight,
        date: new Date(transaction.blockTime),
        senders: [messageSendContent.fromAddress],
        recipients: [messageSendContent.toAddress],
        hasFailed: !transaction.success,
        extra: { memo: memo }
    };
}
/**
 * Fetch operation list
 */
var getOperations = function (accountId, addr, startAt, currencyId) { return __awaiter(void 0, void 0, void 0, function () {
    var rawTransactions, crypto_org_indexer, data, accountTransactions, i, msgs, memo, memoTransaction, j, msgSend;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                rawTransactions = [];
                crypto_org_indexer = (0, logic_1.isTestNet)(currencyId)
                    ? (0, env_1.getEnv)("CRYPTO_ORG_TESTNET_INDEXER")
                    : (0, env_1.getEnv)("CRYPTO_ORG_INDEXER");
                return [4 /*yield*/, (0, network_1["default"])({
                        method: "GET",
                        url: "".concat(crypto_org_indexer, "/api/v1/accounts/").concat(addr, "/transactions?pagination=offset&page=").concat(startAt + 1, "&limit=").concat(PAGINATION_LIMIT)
                    })];
            case 1:
                data = (_a.sent()).data;
                accountTransactions = data.result;
                for (i = 0; i < accountTransactions.length; i++) {
                    msgs = accountTransactions[i].messages;
                    memo = accountTransactions[i].memo;
                    memoTransaction = memo || "";
                    for (j = 0; j < msgs.length; j++) {
                        switch (msgs[j].type) {
                            case sdk_types_1.CryptoOrgAccountTransactionTypeEnum.MsgSend: {
                                msgSend = msgs[j].content;
                                rawTransactions.push(convertSendTransactionToOperation(accountId, addr, msgSend, accountTransactions[i], currencyId, memoTransaction));
                                break;
                            }
                            default:
                        }
                    }
                }
                return [2 /*return*/, rawTransactions];
        }
    });
}); };
exports.getOperations = getOperations;
/**
 * Broadcast blob to blockchain
 */
var broadcastTransaction = function (blob, currencyId) { return __awaiter(void 0, void 0, void 0, function () {
    var client, broadcastResponse;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, getClient(currencyId)];
            case 1:
                client = _a.sent();
                return [4 /*yield*/, client.broadcastTx(chain_jslib_1.utils.Bytes.fromHexString(blob).toUint8Array())];
            case 2:
                broadcastResponse = _a.sent();
                return [2 /*return*/, broadcastResponse];
        }
    });
}); };
exports.broadcastTransaction = broadcastTransaction;
//# sourceMappingURL=sdk.js.map